<!-- Displays a design as a single article -->
<template>
  <div class="row start-md center-xs post-view">
    <div class="col-md-8 col-md-offset-2 col-xs-11 start-xs post">
      <div style="height: 1vw" />

      <!-- Lightbox for the images, transitions every few seconds -->
      <transition
        enter-active-class="animated fadeIn faster"
        leave-active-class="animated fadeOut faster"
      >
        <a :href="image" :key="image" data-lightbox="image-1">
          <img class="main-image" :src="image" />
        </a>
      </transition>
      <!-- Invisible image to keep everything else aligned (transitions require absolute position) -->
      <img :src="image" style="opacity: 0; width: 100%" />

      <div style="height: 4vw" />

      <div class="row">
        <!-- Design attributes (award year, category, etc) -->
        <div class="row col-md-5 col-xs-12">
          <div v-if="$mq === 'lg'" class="nav-col col-md-2 center-md"></div>
          <div class="col-md-9">
            <div class="nom-attributes">
              <div class="row nom-attribute-row">
                <div class="col-xs-4 nom-attribute-name">AWARD YEAR</div>
                <div class="col-xs-8">{{ post.award_year }}</div>
              </div>
              <div class="row nom-attribute-row">
                <div class="col-xs-4 nom-attribute-name">CATEGORY</div>
                <div class="col-xs-8">{{ post.awardcategory.name }}</div>
              </div>
              <div class="row nom-attribute-row">
                <div class="col-xs-4 nom-attribute-name">GOALS</div>
                <div class="col-xs-8">{{ post.challenges | keywords }}</div>
              </div>
              <div class="row nom-attribute-row">
                <div class="col-xs-4 nom-attribute-name">KEYWORDS</div>
                <div class="col-xs-8" style="text-transform: capitalize">
                  {{ post.keywords | keywords }}
                </div>
              </div>
              <div class="row nom-attribute-row">
                <div class="col-xs-4 nom-attribute-name">COUNTRY</div>
                <div class="col-xs-8">{{ post.country.name }}</div>
              </div>
              <div class="row nom-attribute-row">
                <div class="col-xs-4 nom-attribute-name">DESIGNED BY</div>
                <div class="col-xs-8">{{ post.credits }}</div>
              </div>
              <div class="row nom-attribute-row">
                <div class="col-xs-4 nom-attribute-name">WEBSITE</div>
                <div class="col-xs-8">
                  <a
                    :href="post.link"
                    style="
                      color: var(--red);
                      cursor: pointer;
                      text-decoration: none;
                      word-break: break-word;
                    "
                    target="_blank"
                    >{{ post.link }}</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Design title, subtitle and body text -->
        <div class="col-md-6 col-xs-12">
          <div class="title">{{ post.name }}</div>
          <div class="excerpt">{{ post.short_description }}</div>
          <div class="body">
            <div v-if="post.long_description">
              {{ post.long_description }}
            </div>
            <div v-for="i in ['how', 'why', 'dtil']" :key="i">
              <div v-if="post[`${i}_description`]" style="margin: 20px 0">
                <strong>
                  {{ descTitles[i] }}
                </strong>
                <div>{{ post[`${i}_description`] }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Design video -->
        <div style="width: 100%">
          <div
            v-if="post.video"
            class="nom-video row"
            v-html="$options.filters.video(post.video)"
          />

          <div style="height: 5vw" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PostView",
  data() {
    return {
      lightboxTimer: 0,
      descTitles: {
        how: "How does it work?",
        why: "Why is it needed?",
        dtil: "How does it improve life?",
      },
    };
  },
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  computed: {
    // Switches image displayed based on timer
    image() {
      return (
        this.$store.state.storageURL +
        "designs/" +
        this.post["image" + ((this.lightboxTimer % this.images.length) + 1)]
      );
    },
    // Gets all design images into an array
    images() {
      let images = [];
      for (let i = 1; i <= 3; i++) {
        if (this.post["image" + i])
          images.push(
            this.$store.state.storageURL + "designs/" + this.post["image" + i]
          );
      }
      return images;
    },
  },
  methods: {
    lightboxTick() {
      this.lightboxTimer++;
    },
  },
  created() {
    this.$options.interval = setInterval(this.lightboxTick, 5000);
  },
  beforeDestroy() {
    clearInterval(this.$options.interval);
  },
};
</script>

<style scoped>
.post-view {
  width: 100%;
}
.post {
  margin-top: 10px;
  margin-bottom: 20px;
}
@media only screen and (max-width: 767px) {
  .main-image {
    width: 90vw !important;
  }
}
.main-image {
  width: 66.5vw;
  position: absolute;
  z-index: 2;
}

/*----- Navigation -----*/
.nav-col {
  border-right: 1px solid var(--grey100);
  height: fit-content;
}
.nav-back {
  /*border-bottom: 1px solid var(--grey100);*/
}
.nav-element {
  font-size: 30px;
  padding: 15px 0;
}

/*----- Author -----*/
.author {
  font-size: var(--vw16px);
}
.author-image {
  width: 70%;
}
.author-date {
  color: var(--grey600);
  margin-top: 5px;
}

/*----- Nomination attributes -----*/
.nom-attributes {
  /*border-left: 1px solid var(--grey100);*/
  /*height: fit-content;*/
  padding-left: 10px !important;
  font-size: var(--vw14px);
}
.nom-attribute-row {
  margin-bottom: 0.5vw;
  word-break: break-word;
}
.nom-attribute-name {
  color: var(--grey600);
}

/*----- Post content -----*/
.title {
  font-family: IndexDisplay-Bold, Helvetica;
  font-size: var(--vw62px);
  margin-bottom: 20px;
}
@media only screen and (max-width: 767px) {
  .title {
    margin-top: 20px;
  }
}
.excerpt {
  color: var(--grey600);
  font-size: var(--vw22px);
  margin-bottom: 20px;
}
.nom-description {
  font-size: var(--vw17px);
  margin-bottom: 20px;
}
.nom-video {
  margin: 40px 0;
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
}
.nom-video >>> iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

/*----- Post desktop content -----*/
@media only screen and (min-width: 768px) {
  .body {
    font-size: var(--vw17px);
    margin-bottom: 20px;
    word-break: break-word;
    white-space: pre-line;
  }
  .body >>> p {
    margin-left: 27.77vw; /* semi-arbitrary */
    width: 30vw;
  }
  .body >>> ul {
    margin-left: 27.77vw; /* semi-arbitrary */
    width: 30vw;
  }
  .body >>> p > img {
    margin-left: -21vw !important; /* semi-arbitrary */
    width: 59.33vw;
    height: fit-content;
    margin-top: 50px;
    margin-bottom: 50px;
  }
  .body >>> a {
    text-decoration: none;
    color: var(--red);
  }
  .body >>> blockquote {
    margin-left: 12.77vw; /* semi-arbitrary */
    width: 45vw;
    font-size: var(--vw38px);
    margin-top: 60px;
    margin-bottom: 60px;
    font-family: IndexDisplay-Bold, Helvetica;
  }
  .body >>> p > iframe {
    width: 100%;
  }
}

/*----- Post mobile content -----*/
@media only screen and (max-width: 767px) {
  .body {
    font-size: var(--vw17px);
  }
  .body >>> p > img {
    width: 100%;
    height: fit-content;
  }
  .body >>> a {
    text-decoration: none;
    color: var(--red);
  }
  .body >>> blockquote {
    margin: 0; /* semi-arbitrary */
    font-size: var(--vw38px);
    font-family: IndexDisplay-Bold, Helvetica;
  }
  .body >>> p > iframe {
    width: 100%;
    height: 100%;
  }
}
</style>